/**
 * Created by rhinov15 on 26/10/2017.
 *
 * This draw an area (typically areas for zones in the scene like kitchen)
 */

import { PolyNode } from "./PolyNode";
import { GameObjectManager } from "../GameObjectManager";
import { Component, math } from "@rhinov/savane-js";

declare var cc: any;

export class AreaNode extends PolyNode {
    // color of an area when selected
    _SELECTED_COLOR: any =  new cc.color('#F5D231');

    constructor(component: Component, vertices: math.ReadonlyVec3[], color: any, borderColor?: any) {
        super(vertices, color);
        // Border color
        this.areaOutColor = borderColor;
        // Do we display the area vertices
        this._pointsVisible = false;
        // Do we display area dimensions
        this._dimensionsVisible = false;
        // Dimensions to display if above is true
        this._dimensions = [];
        // Is the area closed
        this._closed = true;
        // Is there a line of the area selected (i.e. selected to move it)
        this._lineSelected = null;
        // Is there a point of the area selected (i.e. selected to move it)
        this._pointSelected = null;
        // Component representing the area
        this.component = component;
    }

     // Draws the area
    draw() {
        //Super func is not called on purpose to handle drawing of inside here
        //this._super();

        // Recompute vertices to obtain local vertice positions (they are global in the component)
        // WARNING, this should be changed and removed after a change in smartDesigner and smartRiser
        // That's good because that'd be time consuming anyway
        if (this.component !== undefined) {
            var vertices = [];

            for (var i = 0; i < this.component.vertices.length; i++) {
                var vertice = math.vec3.clone(this.component.vertices[i]);

                vertice[0] -= this.component.entity.transform.globalPosition[0];
                vertice[1] -= this.component.entity.transform.globalPosition[1];
                vertice[2] -= this.component.entity.transform.globalPosition[2];

                vertices.push(vertice);
            }

            this.vertices = vertices;
        }
        // END WARNING TO BE CHANGED

        // Clear polynode
        this.clear();
        // If the area is closed we draw the area inside
        if (this.isClosed()) {
            this.drawInside();
        }
        // We draw the area borders
        this.drawBorder();

        // If we need to show area vertices, draw them
        if (this._pointsVisible) {
            this.drawPoints();
        }

        // Do we have to display area dimensions
        if (this._dimensionsVisible) {
            //FIXME An optim can be made here because most of delete dimensions mahy be instantly recreated
            this.deleteDimensions();
            this._dimensions = GameObjectManager.drawAreaDimensions(this.getName(), this.component.vertices);
        }
    }

    // Draw area border
    drawBorder () {
        // Converted vertices of the area
        var points = [];

        // Parse all vertices of the area and convert them to cocoscoords
        for (var i = 0; i < this.vertices.length; ++i) {
            points.push(GameObjectManager.convertToCocosCoord(this.vertices[i]));
        }

        // Parse all converted points
        for (var i = 0; i < points.length; ++i) {
            // Draw segments between vertices
            if (i < (points.length - 1) || this._closed) {
                // Draw segement with color depending if selected or not
                this.drawSegment(points[i], points[(i + 1) % points.length], 2, i === this._lineSelected ? this._SELECTED_COLOR : this.areaOutColor);
            }
        }
    }

    // Draw vertices
    drawPoints () {
        // Parse all vertices and draw them one after another
        for (var i = 0; i < this.vertices.length; ++i) {
            // Convert point to cocos coords
            var point = GameObjectManager.convertToCocosCoord(this.vertices[i]);

            // And draw the point
            this.drawDot(point, 4 + 1, new cc.color(255, 255, 255));
            this.drawDot(point, 4, i === this._pointSelected ? this._SELECTED_COLOR : new cc.color(125, 0, 255));
        }
    }

    // Activate point display
    setPointVisible (value: boolean) {
        this._pointsVisible = value;
        this.draw();
    }

    // Activate dimension display around the area
    setDimensionsVisible (value: boolean) {
        // ANy change ?
        if (value !== this._dimensionsVisible) {
            // Proceed to change
            this._dimensionsVisible = value;
            // Not visible, free dimensions (they'll be re-created at next activation by the update above)
            if (!this._dimensionsVisible) {
                this.deleteDimensions();
            }
        }
    }

    // Indicate that a line of the area is selected and must be displayed differently
    setLineSelected (lineId: number | null) {
        this._lineSelected = lineId;
    }

    setPointSelected (pointId: number | null) {
        this._pointSelected = pointId;
    }

    // Called when the area is closed (i.e. is a real polygon)
    setClosed (value: boolean) {
        this._closed = value;
        this.draw();
    }

    // Is the area closed
    isClosed () {
        return this._closed && this.vertices.length > 2;
    }

    // Delete dimension nodes if we don't have to display them
    deleteDimensions () {
        // Parse all dimensions array
        for (var i = 0; i < this._dimensions.length; i++) {
            //Remove dimension node
            this._dimensions[i].removeFromParent();
        }
        // Empty dimension array
        this._dimensions = [];
    }

    // Class destruction
    onExit () {
        super.onExit();
        //Clear dimensions on node destroy
        this.deleteDimensions();
    }
}
